// TelcoTrack — status workflow poznámek (Změny oproti PD / Dokumentarista)

export const WORKFLOW_NOTE_STATUSES = {
  /** Výchozí / nevyřešená poznámka (chybějící status = open). */
  OPEN: 'open',
  /** Dokumentarista označil jako vyřešené oproti PD. */
  RESOLVED: 'resolved',
  /** Dokumentarista ignoroval (neřeší se). */
  IGNORED: 'ignored',
} as const;

export type WorkflowNoteStatus =
  (typeof WORKFLOW_NOTE_STATUSES)[keyof typeof WORKFLOW_NOTE_STATUSES];

export const WORKFLOW_NOTE_STATUS_VALUES: readonly WorkflowNoteStatus[] = [
  WORKFLOW_NOTE_STATUSES.OPEN,
  WORKFLOW_NOTE_STATUSES.RESOLVED,
  WORKFLOW_NOTE_STATUSES.IGNORED,
] as const;

export const WORKFLOW_NOTE_STATUS_LABELS_CS: Record<WorkflowNoteStatus, string> = {
  [WORKFLOW_NOTE_STATUSES.OPEN]: 'Nevyřešeno',
  [WORKFLOW_NOTE_STATUSES.RESOLVED]: 'Vyřešeno',
  [WORKFLOW_NOTE_STATUSES.IGNORED]: 'Ignorováno',
};

export function isWorkflowNoteStatus(value: unknown): value is WorkflowNoteStatus {
  return (
    typeof value === 'string' &&
    (WORKFLOW_NOTE_STATUS_VALUES as readonly string[]).includes(value)
  );
}

/** Chybějící / neznámý status = open (nevyřešeno). */
export function normalizeWorkflowNoteStatus(value: unknown): WorkflowNoteStatus {
  if (isWorkflowNoteStatus(value)) return value;
  return WORKFLOW_NOTE_STATUSES.OPEN;
}

export function isUnresolvedWorkflowNoteStatus(value: unknown): boolean {
  return normalizeWorkflowNoteStatus(value) === WORKFLOW_NOTE_STATUSES.OPEN;
}
